import LinkedText from "../LinkedText";
import CogioIcon from "../../assets/img/apps/cogio/cogio.png";
import FundatioIcon from "../../assets/img/apps/fundatio/fundatio.png";

export default function MacAppsTable() {
    const iconStyle = {
        width: "1.5em",
        height: "1.5em",
        objectFit: "contain",
        flexShrink: 0,
        display: "block",
        marginLeft: 0
    };
    
    const appNameStyle = {
        display: "flex",
        alignItems: "center",
        gap: "5px",
    };
    
    const freeStyle = {
        fontWeight: "bold",
        color: "#2aef0c",
    };

    return (
        <>
            <h2 style={appNameStyle}><img style={iconStyle} src={CogioIcon} alt={"Cogio"}/>Cogio</h2>
            <p className="mb-0">An offline-first time tracking app for macOS powered by SQLite.
                <br/>Click <LinkedText to={"/apps/cogio"} text={"here"}/> to learn more.
            </p>
            <h2 style={appNameStyle}><img style={iconStyle} src={FundatioIcon} alt={"Fundatio"}/>Fundatio <span style={freeStyle}>(Free)</span> </h2>
            <p className="mb-0">Project folder structurer with AI assistant for macOS.
                <br/>Click <LinkedText to={"/apps/fundatio"} text={"here"}/> to learn more.
            </p>
        </>
    )
}